module.exports = __webpack_public_path__ + "static/media/cq_euro b.d606f7b5.svg";